import { render } from "./TestimonialPage.vue?vue&type=template&id=75825542&scoped=true&ts=true"
import script from "./TestimonialPage.vue?vue&type=script&lang=ts"
export * from "./TestimonialPage.vue?vue&type=script&lang=ts"

import "./TestimonialPage.vue?vue&type=style&index=0&id=75825542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75825542"]])

export default __exports__